import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=e02021da&scoped=true"
import script from "./CategoryCard.vue?vue&type=script&lang=js"
export * from "./CategoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02021da",
  null
  
)

export default component.exports